/**
 * Vendor apply trade/specialty options.
 *
 * Keep canonical labels aligned with:
 * - backend/src/constants/maintenance-categories.ts
 * - backend/src/services/tenant-chat.helpers.ts (vendorMatchesCategory keywords)
 */

/** One primary label per maintenance ticket category (for outreach matching). */
export const CANONICAL_VENDOR_TRADES = [
  "Plumber",
  "Electrical contractor",
  "HVAC contractor",
  "Appliance repair",
  "Structural repair",
  "Handyman services",
  "Locksmith",
  "Turnover / move-out cleaning",
  "Landscaping",
  "Masonry / tuckpointing",
  "Interior painting",
  "Snow removal",
];

/** Optional subspecialties vendors can select in addition to canonical trades. */
export const ADDITIONAL_VENDOR_TRADES = [
  "Electrician (residential)",
  "Electrician (commercial)",
  "Lighting installation",
  "Solar panel installation",
  "Generator installation",
  "Electrical panel upgrade",
  "Drain cleaning",
  "Water heater installation",
  "Pipe repair/replacement",
  "Sump pump installation",
  "Water line installation",
  "Septic system service",
  "Air conditioning repair",
  "Heating system installation",
  "Duct cleaning",
  "Ventilation systems",
  "Boiler service",
  "Radiant heating",
  "Roofing contractor",
  "Roof repair",
  "Gutter installation",
  "Siding installation",
  "Exterior painting",
  "Pressure washing",
  "Window installation",
  "Door installation",
  "Flooring installation",
  "Carpet installation",
  "Tile installation",
  "Hardwood installation",
  "Hardwood refinishing",
  "Laminate flooring",
  "Concrete flooring",
  "General contractor",
  "Foundation repair",
  "Framing contractor",
  "Drywall installation",
  "Drywall repair",
  "Insulation installation",
  "Basement finishing",
  "Deck construction",
  "Fence installation",
  "Wallpaper installation",
  "Crown molding installation",
  "Cabinet installation",
  "Countertop installation",
  "Bathroom remodeling",
  "Kitchen remodeling",
  "Appliance installation",
  "Security system installation",
  "Smart home installation",
  "Home theater installation",
  "Property maintenance",
  "Cleaning services",
  "Make-ready cleaning",
  "Tree removal",
  "Brick repointing",
  "Snow plowing / ice management",
  "Pest control",
  "Mold remediation",
  "Fire damage restoration",
  "Water damage restoration",
];

/** Sorted, deduped list for the vendor apply multi-select. */
export const VENDOR_TRADE_CATEGORIES = [
  ...new Set([...CANONICAL_VENDOR_TRADES, ...ADDITIONAL_VENDOR_TRADES]),
].sort((a, b) => a.localeCompare(b));
